import { render, staticRenderFns } from "./SortingProductKids.vue?vue&type=template&id=18ef3a4b&scoped=true"
import script from "./SortingProductKids.vue?vue&type=script&lang=js"
export * from "./SortingProductKids.vue?vue&type=script&lang=js"
import style0 from "./SortingProductKids.vue?vue&type=style&index=0&id=18ef3a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef3a4b",
  null
  
)

export default component.exports